"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerProfileClient = void 0;
class CustomerProfileClient {
    constructor(authService, stage) {
        this.authService = authService;
        this.stage = stage;
        this.eTagVersions = new Map();
        this.resourceHostId = `myvw-customer-profile-${this.stage}`;
    }
    async getETag(folder) {
        const url = `v3/customers/__userId__/${folder}`;
        let response;
        try {
            response = await this.authService.get(this.resourceHostId, url);
            const eTag = response.headers.get('eTag');
            if (eTag) {
                this.eTagVersions.set(folder, eTag.replace('W/', ''));
            }
            if (!response.ok) {
                if (response.status === 404) {
                    this.eTagVersions.set(folder, '0');
                }
                throw new Error(`Request failed with status code ${response.status}`);
            }
            return eTag;
        }
        catch (error) {
            if (error instanceof Error) {
                throw new Error(error.message);
            }
            throw new Error('Failed to get personal data');
        }
    }
    async patchPersonalData(payload) {
        const eTag = this.eTagVersions.get('personalData');
        const url = `v3/customers/__userId__/personalData`;
        if (eTag) {
            const response = await this.authService.patch(this.resourceHostId, url, JSON.stringify(payload), {
                'User-Id': '__userId__',
                'If-Match': eTag,
                'Content-Type': 'application/json-patch+json',
            });
            if (!response.ok) {
                throw new Error(`Request failed with status code ${response.status}`);
            }
            const etag = response.headers.get('eTag');
            if (etag) {
                this.eTagVersions.set('personalData', etag.replace('W/', ''));
            }
        }
        else {
            throw Error('No eTag version available');
        }
    }
}
exports.CustomerProfileClient = CustomerProfileClient;
//# sourceMappingURL=CustomerProfileClientV3.js.map